import { AxiosResponse } from 'axios'
import { get, patch, post, upload } from '../../utils/api'

export const fetchBlock = (block_id: string): Promise<AxiosResponse> =>
  get(`/courses/blocks/${block_id}`)

export const fetchLinks = (): Promise<AxiosResponse> => get('/courses/links')

export const createLink = (data: object): Promise<AxiosResponse> =>
  post('/courses/links', data)

export const assignLinksToBlock = (
  block_id: string,
  block_link_id: string,
  links: string[]
): Promise<AxiosResponse> =>
  patch(`/courses/blocks/${block_id}/links/${block_link_id}`, { links })

export const uploadFile = (name: string, file: File): Promise<AxiosResponse> =>
  upload(
    '/courses/media',
    { field: 'file', item: file },
    {
      name,
    }
  )

export const assignFilesToBlock = (
  block_id: string,
  block_file_id: string,
  files: string[]
): Promise<AxiosResponse> =>
  patch(`/courses/blocks/${block_id}/files/${block_file_id}`, { files })

export const fetchVideos = (): Promise<AxiosResponse> => get('/courses/videos')

export const createVideo = (
  caption: string,
  preview_image_url: string,
  url: string
): Promise<AxiosResponse> =>
  post('/courses/videos', { caption, preview_image_url, url })

export const assignVideosToBlock = (
  block_id: string,
  block_video_id: string,
  videos: string[]
): Promise<AxiosResponse> =>
  patch(`/courses/blocks/${block_id}/videos/${block_video_id}`, { videos })

export const assignGalleryToBlock = (
  block_id: string,
  block_gallery_id: string,
  images: string[]
): Promise<AxiosResponse> =>
  patch(`/courses/blocks/${block_id}/gallery/${block_gallery_id}`, { images })
